/**
 * Functions from `easy_points.js`
 *  - updateLoyaltyTargets/0
 *  - updateRedemptionForm/0
 *  - updateDisplayedDiscount/0
 *  - displayDiscount/1
 *  - formatBigNumber/1
 *  - insertPointValue/1
 */

window.addEventListener('load', function() {
  updateLoyaltyTargets();
  EasyPointsIntegration.applyDiscount();

  var pointsInput = getRedeemPointsInputEl();
  if (pointsInput) {
    if (pointsInput.value > 0) {
      updateRedemptionForm();
    }

    pointsInput.addEventListener('focus', function(e) {
      e.target.classList.remove('invalid');
    })
  }

  var redeemBtn = getRedeemPointsButtonEl();
  redeemBtn.addEventListener('click', function(e) {
    e.preventDefault();
    EasyPointsIntegration.handleRedeem();
  });

  var resetBtn = getResetPointsButtonEl();
  resetBtn.addEventListener('click', function(e) {
    e.preventDefault();
    EasyPointsIntegration.handleReset();
  });

  var submissionReady = false;
  var checkoutBtn = getCheckoutButtonEl();
  checkoutBtn.addEventListener('click', function(e) {
    if (!submissionReady) {
      checkoutBtn.style.cursor = 'progress';
      checkoutBtn.setAttribute('disabled', true);

      if (sessionStorage.getItem('appliedDiscount')) {
        form = buildForm('/apps/loyalty/redeem');
      } else {
        form = buildForm('/apps/loyalty/reset');
      }

      if (form) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function(event) {
          if (this.readyState == 4) {
            submissionReady = true;
            checkoutBtn.removeAttribute('disabled');
            checkoutBtn.click();
            checkoutBtn.setAttribute('disabled', true);
          }
        };
        xhr.open('POST', form.action);
        var formData = new FormData(form);
        xhr.send(formData);
      } else {
        submissionReady = true;
        checkoutBtn.removeAttribute('disabled');
        checkoutBtn.click();
        checkoutBtn.setAttribute('disabled', true);
      }
    }
  });
});

function getElementById(selector, message = '') {
  var element = document.getElementById(selector);

  if (element) {
    return element;
  }

  throw Error(message.length > 0 ? message : 'Could not locate ' + selector);
}

function getRedeemPointsButtonEl() {
  return getElementById('redeem-points-button');
}

function getResetPointsButtonEl() {
  return getElementById('reset-points-button');
}

function getRedeemPointsInputEl() {
  return getElementById('shown-point-value');
}

function getCheckoutButtonEl() {
  return getElementById('cart-checkout-button');
}

var EasyPointsIntegration = {
  showResetButton: function() {
    var pointsInput = getRedeemPointsInputEl();
    pointsInput.setAttribute('disabled', true);

    getResetPointsButtonEl().classList.remove('hide');
    getRedeemPointsButtonEl().classList.add('hide');
  },

  hideResetButton: function() {
    var pointsInput = getRedeemPointsInputEl();
    pointsInput.removeAttribute('disabled');

    getResetPointsButtonEl().classList.add('hide');
    getRedeemPointsButtonEl().classList.remove('hide');
  },

  show: function() {
    var nodes = document.getElementsByClassName('hidden-unless-discount-applied');

    Array.prototype.slice.call(nodes).forEach(function(el) {
      el.classList.remove('hide');
    });
  },

  hide: function() {
    var nodes = document.getElementsByClassName('hidden-unless-discount-applied');

    Array.prototype.slice.call(nodes).forEach(function(el) {
      el.classList.add('hide');
    });
  },

  getDiscountSession: function() {
    var discount = sessionStorage.getItem("appliedDiscount");

    return discount ? parseInt(discount) : 0;
  },

  applyCartTotals: function() {
    var discount = this.getDiscountSession();

    var subtotalEl = getElementById('cart-subtotal');
    var subtotal = parseInt(subtotalEl.textContent.replace(/[^\d]/g, ''));
    var subtotalAfterDiscount = subtotal - discount;

    if (subtotalAfterDiscount >= 0) {
      var cartTotalNodes = document.getElementsByClassName('cart-total-after-discount');

      Array.prototype.slice.call(cartTotalNodes).forEach(function(el) {
        el.textContent = '¥' + formatBigNumber(subtotalAfterDiscount);
      });

      var pointsAfterDiscount = getElementById('points-after-applied-discount')
      pointsAfterDiscount.setAttribute('data-loyal-currency-cost', subtotalAfterDiscount * 100);

      insertPointValue(pointsAfterDiscount);
    } else {
      this.handleReset();
    }
  },

  applyDiscount: function() {
    var discount = this.getDiscountSession();

    if (discount > 0) {
      displayDiscount(discount);
      this.showResetButton();
      this.show();
    }

    this.applyCartTotals();
  },

  handleRedeem: function() {
    var input = getRedeemPointsInputEl();
    input.value = input.value.toString().replace(/[^\d]/g, '');

    updateRedemptionForm();

    if (!input.classList.contains('invalid')) {
        updateDisplayedDiscount();
        this.applyDiscount();
    } else {
      sessionStorage.removeItem('appliedDiscount');
    }
  },

  handleReset: function() {
    this.hideResetButton();
    this.hide();

    getRedeemPointsInputEl().value = '';
    sessionStorage.removeItem('appliedDiscount');

    this.applyCartTotals();
  }
};
